import React from 'react';
import { fmtUSD } from '../lib/math';
import { MONTHS } from '../lib/brokerages';

export default function PerDealMatrix({ results, deals }) {
  const sorted = [...deals].sort((a, b) => a.close_month - b.close_month);
  return (
    <div
      className="bg-white rounded-lg border border-slate-200 shadow-sm overflow-hidden mb-8"
      data-testid="bta-per-deal-matrix"
    >
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-slate-50 border-b border-slate-200 text-slate-600">
              <th className="px-3 py-2 text-left bta-sticky-col">Deal</th>
              <th className="px-3 py-2 text-left">Month</th>
              <th className="px-3 py-2 text-right">Sale</th>
              {results.map(({ slot }) => (
                <th
                  key={slot.id}
                  className={'px-3 py-2 text-right ' + (slot.is_current ? 'bg-[#DCD9C8]/50 text-[#092825]' : '')}
                >
                  {slot.name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {sorted.map((d) => (
              <tr key={d.id} className="hover:bg-slate-50/50">
                <td className="px-3 py-2 bta-sticky-col">{d.nickname}</td>
                <td className="px-3 py-2 text-slate-500">{MONTHS[d.close_month]}</td>
                <td className="px-3 py-2 text-right text-slate-500 tabular-nums">{fmtUSD(d.sale_price)}</td>
                {results.map(({ slot, r }) => {
                  const deal = r.perDeal.find((pd) => pd.id === d.id);
                  return (
                    <td
                      key={slot.id}
                      className={
                        'px-3 py-2 text-right tabular-nums ' +
                        (slot.is_current ? 'bg-[#DCD9C8]/30 ' : '') +
                        (deal?.cappedDeal ? 'text-[#2FA163] font-medium' : '')
                      }
                    >
                      {deal ? fmtUSD(deal.net) : '—'}
                      {deal?.cappedDeal && (
                        <span className="text-[10px] text-[#2FA163] ml-1">✓ capped</span>
                      )}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
          <tfoot className="bg-slate-50 border-t-2 border-slate-200 font-bold text-[#092825]">
            <tr>
              <td className="px-3 py-2 bta-sticky-col" colSpan="3">Deal net subtotal</td>
              {results.map(({ slot, r }) => (
                <td
                  key={slot.id}
                  className={'px-3 py-2 text-right tabular-nums ' + (slot.is_current ? 'bg-[#DCD9C8]/40' : '')}
                >
                  {fmtUSD(r.breakdown.totalNetFromDeals)}
                </td>
              ))}
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
}
